import { SimulationConfig, WavePattern } from './types';

export const DEFAULT_CONFIG: SimulationConfig = {
  damping: 0.985,
  frequency: 0.2,
  baseFrequency: 0.2,
  amplitude: 1.0,
  pattern: WavePattern.PRESET,
  autoPlay: true,
  rainMode: false,
  loop: true,
};

export const POOL_SIZE = 200; // Resolution of the physics grid
export const POOL_RADIUS = POOL_SIZE / 2 - 8; // Padding for paddles
export const PADDLE_COUNT = 50; // Number of edge emitters like the real AMOEBA
